export { CommunityLandingPage as default, getServerSideProps } from 'modules/community/pages/CommunityLandingPage'
